





























































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { StudentSubjectRow, StudentSubject, StudentSheet } from "../../modules/student/SheetList"
import StudentSheetListCell from "../../components/StudentSheetListCell.vue";


export interface Data {
  studentSubjectRows: StudentSubjectRow[]
  maxReportCount: number
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Scoring: number; Failure: number; Pass: number;}>
  nextButtonDisabled: boolean
  prevButtonDisabled: boolean
  reportNos: number[]
  examReportNos: number[]
  supplementaryExamReportNos: number[]
  sheetTypes: number[]
  errors: string[]
}

interface DisplayColumn {
  key: string
  kind: "report" | "exam" | "supplementaryExam"
  label: string
  reportNo: number
  sheetType: number
  sourceIndex: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "student-sheet-list-cell": StudentSheetListCell,
  },
  setup(props, context){

    const SheetTypeEnum = Common.SheetTypeEnum;
    
    /******************************
     * 画面データ
     ******************************/

    const state = reactive<Data>({
      studentSubjectRows: [],
      maxReportCount: 0,
      StudentSheetStatusEnum: Common.StudentSheetStatusEnum,
      errors: [],
      nextButtonDisabled: true,
      prevButtonDisabled: true,
      reportNos: [],
      examReportNos: [],
      supplementaryExamReportNos: [],
      sheetTypes: [],
    });

    /******************************
     * 一覧の表示列を種別順に生成
     ******************************/

    const displayColumns = computed<DisplayColumn[]>(() => [
      ...state.reportNos.map((reportNo, sourceIndex) => ({
        key: `report-${reportNo}-${sourceIndex}`,
        kind: "report" as const,
        label: "レポート",
        reportNo,
        sheetType: SheetTypeEnum.Report,
        sourceIndex,
      })),
      ...state.examReportNos.map((reportNo, sourceIndex) => ({
        key: `exam-${reportNo}-${sourceIndex}`,
        kind: "exam" as const,
        label: "試験",
        reportNo,
        sheetType: SheetTypeEnum.ApprovalExam,
        sourceIndex,
      })),
      ...state.supplementaryExamReportNos.map((reportNo, sourceIndex) => ({
        key: `supplementary-exam-${reportNo}-${sourceIndex}`,
        kind: "supplementaryExam" as const,
        label: "追試験",
        reportNo,
        sheetType: SheetTypeEnum.ApprovalExamSupplementary,
        sourceIndex,
      })),
    ]);

    /******************************
     * 表示列に対応する答案を取得
     ******************************/

    const studentSheetFor = (row: StudentSubjectRow, column: DisplayColumn) => {
      if(column.kind == "exam"){
        return row.examStudentSheets[column.sourceIndex];
      }
      if(column.kind == "supplementaryExam"){
        return row.supplementaryExamStudentSheets[column.sourceIndex];
      }
      return row.studentSheets[column.sourceIndex];
    };

    /******************************
     * 試験・追試験のハイフン表示判定
     ******************************/

    const isExamResultEmpty = (row: StudentSubjectRow, column: DisplayColumn) => {
      const studentSheet = studentSheetFor(row, column);
      return !studentSheet || (studentSheet.status != Common.StudentSheetStatusEnum.Failure && studentSheet.status != Common.StudentSheetStatusEnum.Pass);
    };

    /******************************
     * 日時を画面表示文言にコンバート
     ******************************/

    const convertDateString = (date: string) => {
      return date ? moment(date).format('MM月DD日HH時mm分') : "-";
    };

    /******************************
     * 解答画面へ遷移
     ******************************/

    const answerStart = (param: any) => {
      context.root.$store.commit("setIsPreviewMode", param.is_preview_mode);
      setStudentSheetListDispSubjectCodes();
      let url = "";
      if(param.studentSheet){
        const times = param.studentSheet.status == Common.StudentSheetStatusEnum.Failure ? param.studentSheet.times + 1 : param.studentSheet.times;
        url = `/${context.root.$store.state.school_url_prefix}/student_site/digital_report/${param.subject_code}/${param.nendo}/${param.report_no}/${times}`;
      }else{
        url = `/${context.root.$store.state.school_url_prefix}/student_site/digital_report/${param.subject_code}/${param.nendo}/${param.report_no}`;
      }

      context.root.$router.push(url).catch(err => {});
    }

    /******************************
     * 解答画面へ遷移(瑞穂MSC高等学校個社対応)
     * 合格の場合でも1回だけ再提出が可能
     ******************************/

    const answerStartByMizuho = (param: any) => {
      context.root.$store.commit("setIsPreviewMode", param.is_preview_mode);
      setStudentSheetListDispSubjectCodes();
      context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/digital_report/${param.subject_code}/${param.nendo}/${param.report_no}/${param.studentSheet.times + 1}`).catch(err => {});;
    }

    /******************************
     * 試験の結果プレビュー画面へ遷移
     ******************************/

    const goResultImagePreview = (student_sheet_id: number) => {
      setStudentSheetListDispSubjectCodes();
      context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/result_image_preview/${student_sheet_id}`).catch(err => {});
    }

    /******************************
     * 模範解答プレビュー画面へ遷移
     ******************************/

     const goCorrectImagePreview = (base_sheet_id: number) => {
      setStudentSheetListDispSubjectCodes();
      context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/correct_image_preview/${base_sheet_id}`).catch(err => {});
    }

    /******************************
     * 履修科目の表示状態保存
     ******************************/
    
    const setStudentSheetListDispSubjectCodes = () => {
      const subjectCodes = state.studentSubjectRows.filter(x => x.isDisp).map(x => x.studentSubject.subject_code);
      console.log(subjectCodes)
      context.root.$store.commit("setStudentSheetListDispSubjectCodes", subjectCodes);
    }

    /******************************
     * 生徒切り替え
     ******************************/

    const changeStudent = (addIndex: number) => {
      const index = context.root.$store.state.students.findIndex((student: any) => student.student_code === context.root.$store.state.student_code) + addIndex;
      const student: any = context.root.$store.state.students[index];
      context.root.$store.commit("setStudentCode", student.student_code);
      context.root.$store.commit("setStudentName", student.name);
      context.root.$store.commit("setStudentSheetListDispSubjectCodes", []);
      window.location.reload();
    }

    /******************************
     * 初期表示
     ******************************/
    
    onMounted(async () => {

      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      if(context.root.$store.state.currentUser.role != Common.RoleEnum.Student){
        const index = context.root.$store.state.students.findIndex((student: any) => student.student_code === context.root.$store.state.student_code);
        if(index == -1){
          state.prevButtonDisabled = true;
          state.nextButtonDisabled = true;
        }else{
          if(index > 0){
            state.prevButtonDisabled = false;
          }
          if(index + 1 < context.root.$store.state.students.length){
            state.nextButtonDisabled = false;
          }
        }
      }
      
      await http.get(`/api/student/student_sheet_list?student_code=${context.root.$store.state.student_code}`).then(response => {
        state.studentSubjectRows = response.data.student_subject_rows.map((x: any) => new StudentSubjectRow(x));
        state.maxReportCount = response.data.max_report_count;
        state.reportNos = response.data.report_nos || [];
        state.examReportNos = response.data.exam_report_nos || [];
        state.supplementaryExamReportNos = response.data.supplementary_exam_report_nos || [];
        state.sheetTypes = response.data.sheet_types || [];

        state.studentSubjectRows.forEach(x => {
          x.isDisp = context.root.$store.state.studentSheetListDispSubjectCodes.includes(x.studentSubject.subject_code)
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      SheetTypeEnum,
      displayColumns,
      studentSheetFor,
      isExamResultEmpty,
      convertDateString,
      answerStart,
      answerStartByMizuho,
      goResultImagePreview,
      goCorrectImagePreview,
      changeStudent,
    }
  }
});
